import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/2d-game/game_banner.webp";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                2D Game Development Company
              </h1>
              <span>
                Engaging <span style={{ color: "#f47a14" }}>Games</span> with
                Latency-
                <span style={{ color: "#f47a14" }}>Free Experiences</span>
              </span>
              <p style={{ marginTop: "10px" }}>
                Our 2D game development services help you design interactive
                environments with highly responsive functionalities for rich
                narrative experiences. Our game development approach spans a
                player-first design philosophy, immersive storytelling, and
                zero-lag gameplay for every project we take on – making TekRevol
                your ideal 2D game development company.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Game Idea
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
